
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_1ykar_13gpv_94",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1ykar_13gpv_1",
  "root": "awsui_root_1ykar_13gpv_125",
  "calendar-inner": "awsui_calendar-inner_1ykar_13gpv_142",
  "calendar-header": "awsui_calendar-header_1ykar_13gpv_145",
  "calendar-header-month": "awsui_calendar-header-month_1ykar_13gpv_150",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_1ykar_13gpv_157",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_1ykar_13gpv_160",
  "calendar-grid": "awsui_calendar-grid_1ykar_13gpv_163",
  "calendar-grid-cell": "awsui_calendar-grid-cell_1ykar_13gpv_167",
  "calendar-day-header": "awsui_calendar-day-header_1ykar_13gpv_173",
  "calendar-day": "awsui_calendar-day_1ykar_13gpv_173",
  "calendar-day-enabled": "awsui_calendar-day-enabled_1ykar_13gpv_190",
  "calendar-day-current-month": "awsui_calendar-day-current-month_1ykar_13gpv_197",
  "calendar-day-selected": "awsui_calendar-day-selected_1ykar_13gpv_204",
  "calendar-day-today": "awsui_calendar-day-today_1ykar_13gpv_207",
  "day-inner": "awsui_day-inner_1ykar_13gpv_222",
  "calendar-week": "awsui_calendar-week_1ykar_13gpv_287"
};
  